import { Injectable, resource, signal } from '@angular/core';
import { Jobopslag } from '@features/letpensiondk/letpensiondk-jobopslag/jobopslag.model';
import { RestDatasource } from '@core/api/rest.datasource';
import { JobopslagSearchParams } from '@features/letpensiondk/letpensiondk-jobopslag/jobopslag-search-params.model';

@Injectable({
  providedIn: 'root',
})
export class JobopslagDatasource extends RestDatasource<Jobopslag> {
  override endpoint = '/api/admin/jobopslag';

  searchParams = signal<JobopslagSearchParams>({
    text: '',
    medtagSlettede: false,
  });

  override data = resource({
    params: () => this.searchParams(),
    loader: async ({ params, abortSignal }) => {
      return await this.getList(
        {
          filter: JSON.stringify(params),
          sortBy: 'sekvensNr',
        },
        abortSignal
      );
    },
  });
}
